import {Injector} from "@angular/core";

/**
 * This class is created for the sole purpose of being an injector
 * retrieval system for the RestApiService
 */
export class ServiceLocatorService {
  static injector: Injector;
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/services/base-api/service-locator.service.ts